import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'

interface IProps {
  lng: string
  productId: string
}

interface IAccountProps {
  lng: string
  accountId: string
}

export function createProductQRLink({ lng, productId }: IProps) {
  const url = createJourneyPageURL()
  if (lng === DEFAULT_LANGUAGE_CODE) {
    return `${url}/${productId}`
  }
  return `${url}/${lng}/${productId}`
}

export function createAccountQRLink({ lng, accountId }: IAccountProps) {
  const url = createJourneyPageURL()

  if (lng === DEFAULT_LANGUAGE_CODE) {
    return `${url}/account/${accountId}`
  }

  return `${url}/${lng}/account/${accountId}`
}

export function createJourneyPageURL() {
  const isProd = process.env.REACT_APP_STATUS_ENV === 'prod'
  const env = isProd ? '' : '-' + process.env.REACT_APP_STATUS_ENV

  return `https://journey${env}.trackgood.io`
}
